export default __webpack_public_path__ + "static/media/fuel-consumed-icon.91337685.svg";